/* eslint-disable react/jsx-props-no-spreading */
import { Paper, Grid2 as Grid } from "@mui/material";
import { useState } from "react";
import type { FormData } from "./template-advanced-config";
import type {
  TemplateInformation,
  AvailableValidCharacterItem,
  ValidCharacterItem,
} from "../types/api-types";
import TemplateFormHeader from "./template-form-header";
import TemplateBasicInfo from "./template-basic-info";
import TemplateConfigFields from "./template-config-fields";
import TemplateAdvancedSection from "./template-advanced-section";
import TemplateFormActions from "./template-form-actions";

interface TemplateFormProps {
  selectedTemplate: TemplateInformation;
  formData: FormData;
  isSaving: boolean;
  availableValidCharacters: AvailableValidCharacterItem[];
  isLoadingValidCharacters: boolean;
  onFormDataChange: React.Dispatch<React.SetStateAction<FormData>>;
  onToggleValidator: (checked: boolean) => void;
  onSave: () => void;
  onCancel: () => void;
  onSaveValidCharacters: (
    added: ValidCharacterItem[],
    deleted: ValidCharacterItem[],
  ) => Promise<void>;
}

const TemplateForm = ({
  selectedTemplate,
  formData,
  isSaving,
  availableValidCharacters,
  isLoadingValidCharacters,
  onFormDataChange,
  onToggleValidator,
  onSave,
  onCancel,
  onSaveValidCharacters,
}: TemplateFormProps) => {
  const [showAdvancedConfig, setShowAdvancedConfig] = useState(false);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: 1,
        borderColor: "divider",
        borderRadius: 2,
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: 2,
        },
      }}
    >
      <TemplateFormHeader
        templateDescription={selectedTemplate.description}
        useDataValidator={formData.useDataValidator}
        isSaving={isSaving}
        onToggleValidator={onToggleValidator}
      />

      <Grid container spacing={1.5}>
        <TemplateBasicInfo
          templateId={selectedTemplate.id}
          description={selectedTemplate.description}
        />

        <TemplateConfigFields
          formData={formData}
          onFormDataChange={onFormDataChange}
        />

        <TemplateAdvancedSection
          showAdvancedConfig={showAdvancedConfig}
          onToggleAdvanced={() => setShowAdvancedConfig(!showAdvancedConfig)}
          templateId={selectedTemplate.id}
          formData={formData}
          availableValidCharacters={availableValidCharacters}
          isLoadingValidCharacters={isLoadingValidCharacters}
          onFormDataChange={onFormDataChange}
          onSaveValidCharacters={onSaveValidCharacters}
        />

        <TemplateFormActions
          isSaving={isSaving}
          onSave={onSave}
          onCancel={onCancel}
        />
      </Grid>
    </Paper>
  );
};

export default TemplateForm;
